import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isPatientMode } from '../../../../platform/app/src/custom/utils/patientMode';
import {
  getPatientViewLanguage,
  setPatientViewLanguage,
  resetI18nToStaffDefault,
  STAFF_DEFAULT_LANG,
} from '../../../../platform/app/src/custom/utils/patientViewLanguage';

const LANG_EN = STAFF_DEFAULT_LANG;
const LANG_HI = 'hi';

/**
 * Compact EN | हिं language toggle for patient viewer chrome.
 * Language preference is session-scoped to patient mode so staff UI is not polluted.
 */
function PatientLanguageToggle() {
  const { t, i18n } = useTranslation('PatientView');
  const isHindi = (i18n.language || '').toLowerCase().startsWith('hi');

  useEffect(() => {
    if (!isPatientMode()) {
      resetI18nToStaffDefault();
      return;
    }
    const preferred = getPatientViewLanguage();
    if ((i18n.language || '').toLowerCase() !== preferred.toLowerCase()) {
      void i18n.changeLanguage(preferred);
    }
  }, [i18n]);

  const setLanguage = (lng: string) => {
    if (!isPatientMode()) {
      return;
    }
    if ((i18n.language || '').toLowerCase() === lng.toLowerCase()) {
      return;
    }
    setPatientViewLanguage(lng);
    void i18n.changeLanguage(lng);
  };

  const segmentClass = (active: boolean) =>
    [
      'viewer-ris-header-typography inline-flex min-h-8 min-w-[2.25rem] items-center justify-center rounded px-2 text-sm font-medium transition-colors',
      active
        ? 'bg-[#0891B2] text-white'
        : 'bg-transparent text-[#15294b] hover:bg-[#0891B2]/10',
    ].join(' ');

  return (
    <div
      role="group"
      aria-label={t('Language')}
      className="inline-flex items-center gap-0.5 rounded-md border border-[#e2e8f0] bg-white p-0.5"
    >
      <button
        type="button"
        className={segmentClass(!isHindi)}
        aria-pressed={!isHindi}
        onClick={() => setLanguage(LANG_EN)}
      >
        EN
      </button>
      <button
        type="button"
        className={segmentClass(isHindi)}
        aria-pressed={isHindi}
        onClick={() => setLanguage(LANG_HI)}
      >
        हिं
      </button>
    </div>
  );
}

export default PatientLanguageToggle;
